import { LANTERNS, GLOWS, PETALS } from "../../constants/particles";

export const SceneLayers = ({ art, lanternsOff, onLanternClick }) => {
  return (
    <div id="stage">
      <div id="art">
        <img id="bgArt" alt="" src={art.bg} />
        <div className="ov" id="moonBreath"></div>
        {LANTERNS.map((l, i) => (
          <div
            key={i}
            className={`lant${lanternsOff[i] ? " off" : ""}`}
            style={{ left: `${l.left}%`, top: `${l.top}%` }}
            onClick={() => onLanternClick(i)}
          ></div>
        ))}
        <div id="glows">
          {GLOWS.map((g, i) => (
            <div
              key={i}
              className={`fb${g.variant ? " " + g.variant : ""}`}
              style={{ left: `${g.left}%`, top: `${g.top}%`, "--d": `${g.d}s`, "--dl": `${g.dl}s` }}
            ></div>
          ))}
        </div>
        {PETALS.map((p, i) => (
          <div
            key={i}
            className="pt"
            style={{
              left: `${p.left}%`, top: `${p.top}%`,
              "--pw": `${p.pw}px`, "--ph": `${p.ph}px`,
              "--pd": `${p.pd}s`, "--pdel": `${p.pdel}s`,
            }}
          ></div>
        ))}
        <div id="cloud"><img id="cloudImg" alt="" src={art.cloud} /></div>
        <img id="fgArt" alt="" src={art.fg} />
        <div id="swing"><img id="cutImg" alt="" src={art.subject} /></div>
      </div>
    </div>
  );
};
